export { Table, type TableProps } from './Table'
